module.exports = "//static.hsappstatic.net/marketplace-unified-public-base/static-1.1171/img/app-marketplace-network-1x.png"